import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import AreaMaestranza from "../pages/area-maestranza/page";
import AreaTransporte from "../pages/area-transporte/page";
import ArriendoMaquinarias from "../pages/arriendo-maquinarias/page";
import Galeria from "../pages/galeria/page";
import Contacto from "../pages/contacto/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/area-maestranza",
    element: <AreaMaestranza />,
  },
  {
    path: "/area-transporte",
    element: <AreaTransporte />,
  },
  {
    path: "/arriendo-maquinarias",
    element: <ArriendoMaquinarias />,
  },
  {
    path: "/galeria",
    element: <Galeria />,
  },
  {
    path: "/contacto",
    element: <Contacto />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
